"use client";
import * as React from "react";
const SvgBoltRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 9 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M3.3 16a.52.52 0 0 1-.51-.59l.8-5.63H.46c-.8 0-.3-.67-.28-.7L5.25.26A.5.5 0 0 1 5.7 0c.32 0 .56.28.51.59l-.8 5.63h3.15c.36 0 .56.17.36.59l-5.17 8.93a.5.5 0 0 1-.45.26" }));
export {
  SvgBoltRound as default
};
